import React, { useState, useEffect } from 'react';
import {
	Paper,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	TableContainer,
	TablePagination,
	Checkbox,
} from '@material-ui/core';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CustomButton from '../../../layout/customButton/CustomButton';
import Modal from '../../../layout/modal/Modal';
import EditLotPricing from './editLotPricing/EditLotPricing';
import styles from './LotsPricing.module.scss';
import { connect } from 'react-redux';
import { setAlert } from '../../../../redux/alerts/action';

const LotsPricing = (props) => {
	const [selected, setSelected] = useState([]);
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [editLotsPricingModal, setEditLotsPricingModal] = useState(false);
	const [editLotInfo, setEditLotInfo] = useState();
	const [lotIdArr, setLotIdArr] = useState([]);
	const [filteredLots, setFilteredLots] = useState([]);

	const { lots, setAlert, filteredLotSizeType, search } = props;

	useEffect(() => {
		if (selected.length === 1) {
			setEditLotInfo(lots.filter((lot) => lot.lot === selected[0])[0]);
			setLotIdArr([]);
		} else if (selected.length > 1) {
			setEditLotInfo();
			setLotIdArr(selected);
		} else {
			setEditLotInfo();
			setLotIdArr([]);
		}
	}, [selected, lots]);

	useEffect(() => {
		if (filteredLotSizeType) {
			setFilteredLots(
				lots
					.filter((lot) => lot.lotSizeType === filteredLotSizeType)
					.filter((lot) => {
						if (search) {
							return lot.lot?.toString() === search;
						} else {
							return true;
						}
					})
			);
			setPage(0);
		} else {
			setFilteredLots(
				lots.filter((lot) => {
					if (search) {
						return lot.lot?.toString() === search;
					} else {
						return true;
					}
				})
			);
			setPage(0);
		}
	}, [lots, filteredLotSizeType, search]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const getLotPremiumPrice = (pricing) => {
		if (pricing) {
			let premiumPricing = pricing.filter(
				(item) => item.name === 'Lot Premium'
			);
			if (premiumPricing.length > 0) {
				return parseFloat(premiumPricing[0].price);
			} else {
				return 0;
			}
		} else {
			return 0;
		}
	};

	const getLotUpgradePrice = (pricing) => {
		if (pricing) {
			let upgradePricing = pricing
				.filter((item) => item.name !== 'Lot Premium')
				.reduce((prev, curr) => prev + curr.price, 0);
			return parseFloat(upgradePricing);
		} else {
			return 0;
		}
	};

	const getLotTotalPrice = (lotPrice, pricing) => {
		let premiumPricing = getLotPremiumPrice(pricing);
		let upgradePricing = getLotUpgradePrice(pricing);
		return lotPrice + premiumPricing + upgradePricing;
	};

	const isLotSelected = (name) => selected.indexOf(name) !== -1;

	const handleSelectLots = (event) => {
		if (event.target.checked) {
			const newSelecteds = lots.map((n) => n.lot);
			setSelected(newSelecteds);
			return;
		}
		setSelected([]);
	};

	const handleSelectLot = (event, lot) => {
		const selectedIndex = selected.indexOf(lot);
		let newSelected = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(selected, lot);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(selected.slice(1));
		} else if (selectedIndex === selected.length - 1) {
			newSelected = newSelected.concat(selected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				selected.slice(0, selectedIndex),
				selected.slice(selectedIndex + 1)
			);
		}
		setSelected(newSelected);
	};

	const handleEditLot = () => {
		if (selected.length === 0) {
			setAlert('warning', 'Please select at least one lot.');
		} else {
			openEditLotsPricingModal();
		}
	};

	const openEditLotsPricingModal = () => {
		setEditLotsPricingModal(true);
	};

	const closeEditLotsPricingModal = () => {
		setEditLotsPricingModal(false);
	};

	return (
		<Paper className={styles.lots_pricing}>
			<div className={styles.lots_pricing_header}>
				<h2 className={styles.lots_pricing_header_title}>Pricing</h2>
				<CustomButton width={102} height={42} onClick={handleEditLot}>
					Edit Lots
				</CustomButton>
			</div>
			<TableContainer className={styles.lots_pricing_content}>
				<Table>
					<TableHead>
						<TableCell padding='checkbox'>
							<Checkbox
								className={styles.lots_pricing_table_checkbox}
								checkedIcon={
									<CheckBoxIcon className={styles.checkbox} />
								}
								onChange={handleSelectLots}
							/>
						</TableCell>
						<TableCell>#Lot</TableCell>
						<TableCell>Lot Size (sq.m)</TableCell>
						<TableCell>Grade</TableCell>
						<TableCell>Upgrade</TableCell>
						<TableCell>Premium</TableCell>
						<TableCell>Total</TableCell>
					</TableHead>
					<TableBody>
						{filteredLots
							.slice(
								page * rowsPerPage,
								page * rowsPerPage + rowsPerPage
							)
							.map((item) => {
								const isItemSelected = isLotSelected(item.lot);

								return (
									<TableRow
										hover
										key={item.lot}
										role='checkbox'
									>
										<TableCell padding='checkbox'>
											<Checkbox
												className={
													styles.lots_pricing_table_checkbox
												}
												checkedIcon={
													<CheckBoxIcon
														className={
															styles.checkbox
														}
													/>
												}
												checked={isItemSelected}
												onClick={(event) =>
													handleSelectLot(
														event,
														item.lot
													)
												}
											/>
										</TableCell>
										<TableCell component='th' scope='row'>
											{item.lot}
										</TableCell>
										<TableCell component='th' scope='row'>
											{item.lotSize}
										</TableCell>
										<TableCell component='th' scope='row'>
											{getLotPremiumPrice(item?.pricing)}
										</TableCell>
										<TableCell component='th' scope='row'>
											{getLotUpgradePrice(item?.pricing)}
										</TableCell>
										<TableCell component='th' scope='row'>
											{item.lotPrice}
										</TableCell>
										<TableCell component='th' scope='row'>
											{getLotTotalPrice(
												item.lotPrice,
												item?.pricing
											)}
										</TableCell>
									</TableRow>
								);
							})}
					</TableBody>
				</Table>
			</TableContainer>
			<TablePagination
				rowsPerPageOptions={[5, 10, 25]}
				component='div'
				count={filteredLots.length}
				rowsPerPage={rowsPerPage}
				page={page}
				onPageChange={handleChangePage}
				onRowsPerPageChange={handleChangeRowsPerPage}
				labelRowsPerPage={
					<div style={{ color: 'var(--text-high-emphasis)' }}>
						Rows per page
					</div>
				}
				nextIconButtonProps={{
					style: {
						padding: '0px',
					},
				}}
				backIconButtonProps={{
					style: {
						padding: '0px',
						marginLeft: '-10px',
					},
				}}
				SelectProps={{
					style: {
						border: '1px solid var(--text-mid-emphasis)',
						borderRadius: '4px',
						padding: '4px',
						marginRight: '10px',
					},
				}}
			/>
			<div className={styles.edit_lot_pricing_modal}>
				<Modal
					show={editLotsPricingModal}
					close={closeEditLotsPricingModal}
				>
					<EditLotPricing
						editLotInfo={editLotInfo}
						closeEditLotsPricingModal={closeEditLotsPricingModal}
						lotIdArr={lotIdArr}
					/>
				</Modal>
			</div>
		</Paper>
	);
};

const mapStateToProps = (state) => ({
	lots: state.siteplanManagement.lots,
});

export default connect(mapStateToProps, { setAlert })(LotsPricing);
